import React from "react";
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-anonymous-default-export
export default function (Component) {
    class AuthenticatedComponent extends React.Component {

        constructor(props) {
            super(props);
            this.state = {
              isTokenValid: true
            }
        }
        componentDidMount() {
            this.checkAndRedirect();
          }
          checkAndRedirect() {
            let decodedLocalToken = this.props && this.props.loginDetailsSlice && this.props.loginDetailsSlice.decodedToken;
            if (decodedLocalToken && Date.now() > decodedLocalToken.exp * 1000) {
                // invalid token case
                this.setState({isTokenValid:false});
                localStorage.setItem('state', '');
                window.location = localStorage.getItem('dplocation');
            }
            else{
                this.setState({isTokenValid:true});
            }
          }

        render() {
            const tokenErrorMessage = (
                <div>
                    Session has expired!! Please login.
                </div>
            );
            return (
                <div>
                    { this.state.isTokenValid === true ? <Component {...this.props} /> : tokenErrorMessage }
                </div>
            );
        }
    };

const mapStateToProps = (state) => { return state};

return connect(mapStateToProps)(AuthenticatedComponent)
}

